import { isDefined } from '@csp/csp-common-util';
import { ArchiveFileClassificationAggregationV1 } from '@csp/dmdp-api-file-storage-archiving-dto';
import { FolderTree } from '../model/FolderTree';

const toFolderTree = (folderTree: ArchiveFileClassificationAggregationV1[]): FolderTree[] =>
  folderTree
    .map(({ classificationLevelName, classificationPath, subClassifications, fileCount, totalFileSize }) => ({
      name: classificationLevelName,
      folderPath: classificationPath,
      fileCount,
      totalFileSize,
      subFolders: subClassifications ? toFolderTree(subClassifications) : undefined,
    }))
    .filter(isDefined);

export const ArchiveFilesClassificationAggregationMapper = {
  toFolderTree,
};
